import router from "../../../router";
export default {
    name: 'NewBusinessBusinessExemption',
    props: {
        title: String,
        instruction: String
    },
    data() {
        return {
           is_business_exemption_accepted: (this.$store.state.sessionDetails.properties.small_business_disclaimer == true) ? true : false,
           businessExemptionSubmitted: false,
        }
    },
    methods: {
        checkStoreData() {
            console.debug('Payload Build Structure', this.$store.getters.sessionPayload);
        },
        backToPrevious() {
            this.$store.commit('mutate', {
                property: "NewBusinessStep",
                value: this.$store.state.NewBusinessStep - 1
            });
        },
        initApp() {
            this.checkStoreData();
        },
        submitForm() {
            this.businessExemptionSubmitted = true;
            this.$emit("createUpdateSession");
        },
        acceptBusinessExemption(response) {
            this.is_business_exemption_accepted = response;
            this.$store.commit('mutate', {
                property: "sessionDetails.properties.small_business_disclaimer",
                value: this.is_business_exemption_accepted
            });
        }
    },
    mounted() {
        this.initApp();
    }
}